var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_642_17255)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6862 3.31378C21.4853 3.11289 21.2127 3 20.9286 3H10.2142C9.36188 3 8.5439 3.33865 7.94133 3.94133C7.33876 4.54401 7 5.36199 7 6.21424V29.7858C7 30.6381 7.33865 31.4561 7.94133 32.0587C8.54401 32.6612 9.36199 33 10.2142 33H25.2143C26.0667 33 26.8846 32.6614 27.4872 32.0587C28.0898 31.456 28.4285 30.638 28.4285 29.7858V10.5C28.4285 10.2158 28.3157 9.9432 28.1148 9.74231L21.6862 3.31378ZM22 6.65775L24.7709 9.42866H23.0714C22.4798 9.42866 22 8.9489 22 8.35723V6.65775ZM25.2143 30.8574H10.2142C9.62256 30.8574 9.14281 30.3777 9.14281 29.786V6.21448C9.14281 5.62281 9.62256 5.14305 10.2142 5.14305H19.8571V8.35735C19.8571 9.20971 20.1958 10.0277 20.7985 10.6303C21.4011 11.2328 22.2191 11.5716 23.0714 11.5716H26.2857V29.7859C26.2857 30.0701 26.1728 30.3427 25.9719 30.5436C25.771 30.7445 25.4984 30.8574 25.2143 30.8574Z",
    fill: "#414042",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2861 13.7146H24.1433V15.8575H11.2861V13.7146Z",
    fill: "#414042",
    stroke: "#414042",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2861 18.0005H24.1433V20.1433H11.2861V18.0005Z",
    fill: "#414042",
    stroke: "#414042",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2861 22.2863H24.1433V24.4291H11.2861V22.2863Z",
    fill: "#414042",
    stroke: "#414042",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2861 26.5721H24.1433V28.7149H11.2861V26.5721Z",
    fill: "#414042",
    stroke: "#414042",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2861 9.42911H17.7147V11.572H11.2861V9.42911Z",
    fill: "#414042",
    stroke: "#414042",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_642_17255"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.eef74100febad1d04a862b4b304e2589.svg";
export { ForwardRef as ReactComponent };